import * as Modal from '#/components/shared/Modal';

import {
  useDepositModalActions,
  useDepositModalView,
} from '#/features/deposit/modal-context';
import { DepositFormProvider } from '#/features/deposit/form-context';
import {
  DepositProvider,
  useDepositView,
} from '#/features/deposit/deposit-context';
import { useTranslation } from '#/features/localization/utils';

import DepositForm from './DepositForm';

export default function DepositModal() {
  const modalView = useDepositModalView();

  // Avoid rendering the provider if the modal is closed
  // so that state is not initialized unnecessarily and
  // is properly reset when the modal is opened again.
  if (!modalView.isOpen) return null;

  return (
    <DepositProvider>
      <DepositModalInternal />
    </DepositProvider>
  );
}

function DepositModalInternal() {
  const modalActions = useDepositModalActions();
  const depositView = useDepositView();
  const { t } = useTranslation();

  const close = () => {
    modalActions.close();
  };

  const onDismiss = () => {
    if (depositView.isBusy) return;
    modalActions.close();
  };

  return (
    <Modal.Root onDismiss={onDismiss} aria-labelledby="deposit-modal-title">
      <Modal.Header>
        <Modal.Title id="deposit-modal-title">{t('Deposit')}</Modal.Title>
        {!depositView.isBusy && <Modal.CloseButton onClick={close} />}
      </Modal.Header>
      <DepositFormProvider>
        <DepositForm />
      </DepositFormProvider>
    </Modal.Root>
  );
}
